<template>
  <Card class="mt-3 requirements-contrainer">
    <div class="cardTitle">{{ $t('Требования к участнику {_1}', { '_1': supplierRequirements.length }) }}</div>
    <div
      class="d-flex flex-column ga-3 requirements-container-scroll"
    >
      <div
        v-for="(requirement, i) in supplierRequirements"
        :key="i"
      >
        <div class="d-flex flex-row">
          <div
            class="requirement-title"
            :class="{'required': requirement.isRequired}"
          >
            <v-icon
              :icon="getIconByType(requirement.type)"
            />
            {{ requirement.name }}
          </div>
        </div>
        <div class="cardSubTitle">
          <div>
            {{ getDescription(requirement) }}
          </div>
          <div
            v-if="requirement.type === SUPPLIER_REQUIREMENT_TYPE.LIST"
            class="pl-7"
          >
            <ul>
              <li
                v-for="(item, j) in requirement.list"
                :key="j">
                {{ item.value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@intec/vue-components/form/Card.vue";
import { getIconByType, SUPPLIER_REQUIREMENT_TYPE } from '@/lib/supplierRequirement';

export default {
  name: 'ProcedureSupplierRequirementsInfo',
  components: {Card},
  props: {
    supplierRequirements: {
      type: Array,
      required: true
    }
  },
  methods: {
    getIconByType,
    getDescription(requirement) {
      const description = requirement.description.trim()
      if (requirement.type !== SUPPLIER_REQUIREMENT_TYPE.LIST) {
        return description;
      }
      const lastMessage = this.$t('Выбор одного варианта.')
      if (description.endsWith('.')) {
        return description + ' ' + lastMessage
      }

      return description + '. ' + lastMessage
    },
  },
  data() {
    return {
      SUPPLIER_REQUIREMENT_TYPE,
    };
  },
}
</script>

<style lang="scss" scoped>
.requirements-contrainer {
  box-shadow: none;
  padding: 0;

  .requirements-container-scroll {
    max-height: 580px;
    overflow-y: auto;
  }

  .requirement-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  .required::after {
    content: ' *';
    color: rgba(var(--error-color));
  }
}
</style>
